export const mobile = () => {
  const navExpand = [].slice.call(document.querySelectorAll(".nav-expand"));
  const backLink = `<li class="nav-item">
	<a class="nav-link nav-back-link" href="javascript:;">
		Regresar
	</a>
</li>`;

  navExpand.forEach(item => {
    item
      .querySelector(".nav-expand-content")
      .insertAdjacentHTML("afterbegin", backLink);
    item
      .querySelector(".nav-link")
      .addEventListener("click", () => item.classList.add("active"));
    item
      .querySelector(".nav-back-link")
      .addEventListener("click", () => item.classList.remove("active"));
  });

  const mobileMenu = document.querySelector('.mobile-menu')
  const innerMenu = document.querySelectorAll('.nav-items')
  const ham = document.getElementById("ham");
  ham.addEventListener("click", function(e) {
    e.stopPropagation()
    mobileMenu.classList.toggle("nav-is-toggled");
  });

  window.mobileMenu = mobileMenu
};
